import { defaultTheme } from "@cobee/cobee-ui";

const styles = {
  title: {
    marginBottom: defaultTheme.spacing(1),
  },
  buttonContainer: {
    marginTop: defaultTheme.spacing(3),
  },
};

export default styles;
